/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountSummaryVo from './AccountSummaryVo';




  /**
   * The AccountFreezeStatusVo model module.
   * @module account_mgt/model/AccountFreezeStatusVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountFreezeStatusVo</code>.
   * @alias module:account_mgt/model/AccountFreezeStatusVo
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>AccountFreezeStatusVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/AccountFreezeStatusVo} obj Optional instance to populate.
   * @return {module:account_mgt/model/AccountFreezeStatusVo} The populated <code>AccountFreezeStatusVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'freezeUntil')) {
        obj['freezeUntil'] = ApiClient.convertToType(data['freezeUntil'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'reason')) {
        obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'enable')) {
        obj['enable'] = ApiClient.convertToType(data['enable'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'passwordChangedAt')) {
        obj['passwordChangedAt'] = ApiClient.convertToType(data['passwordChangedAt'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'rAccount')) {
        obj['rAccount'] = AccountSummaryVo.constructFromObject(data['rAccount']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * 冻结记录id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 账号id
   * @member {Integer} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * 冻结截止时间
   * @member {Date} freezeUntil
   */
  exports.prototype['freezeUntil'] = undefined;
  /**
   * 冻结原因
   * @member {String} reason
   */
  exports.prototype['reason'] = undefined;
  /**
   * 生效标记 1:生效; null:失效
   * @member {Integer} enable
   */
  exports.prototype['enable'] = undefined;
  /**
   * 封控要求改密完成时间，null表示尚未完成
   * @member {Date} passwordChangedAt
   */
  exports.prototype['passwordChangedAt'] = undefined;
  /**
   * @member {module:account_mgt/model/AccountSummaryVo} rAccount
   */
  exports.prototype['rAccount'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


